import { atom, useAtom } from 'jotai';
var TRIGGER_TABLE_ONCHANGE = /*#__PURE__*/atom(false);
var PAGINATE = /*#__PURE__*/atom(false);

var useTableStates = function useTableStates() {
  var TRIGGER_STATE = useAtom(TRIGGER_TABLE_ONCHANGE);
  var PAGINATE_STATE = useAtom(PAGINATE);
  return {
    trigger: TRIGGER_STATE,
    paginate: PAGINATE_STATE
  };
};

var IS_MENU_OPEN = /*#__PURE__*/atom(true);

function useMenuState() {
  var _useAtom = useAtom(IS_MENU_OPEN),
      isOpen = _useAtom[0],
      setOpen = _useAtom[1];

  var openMenu = function openMenu() {
    return setOpen(true);
  };

  var closeMenu = function closeMenu() {
    return setOpen(false);
  };

  var toggleMenu = function toggleMenu() {
    return setOpen(!isOpen);
  };

  return {
    isOpen: isOpen,
    openMenu: openMenu,
    closeMenu: closeMenu,
    toggleMenu: toggleMenu
  };
}

var TEST_ATOM = /*#__PURE__*/atom(false);
export { IS_MENU_OPEN, PAGINATE, TEST_ATOM, TRIGGER_TABLE_ONCHANGE, useMenuState, useTableStates };